/* global mapboxgl */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Immutable from 'immutable';

import { clickMap, setStyle } from '../actions/index';
import diffStyles from '../utilities/diff.js';

import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";

class ReactMap extends Component {
  componentDidMount(){
    // set map properties
    // key1,key2 .... assign the values

    const { token, longitude, latitude, zoom, styleID } = this.props;
    const mapConfig = {
      container: 'map',
      style: `mapbox://styles/${ styleID }`,
      center: [longitude, latitude],
      zoom: zoom, // starting zoom
      pitch:60,
    };

    mapboxgl.accessToken = token;
    this.map = new mapboxgl.Map(mapConfig);


    ////////////////////////////////// some mapbox function ////////////////////
    // Add zoom and rotation controls to the map.
    this.map.addControl(
        new MapboxGeocoder({
          accessToken: mapboxgl.accessToken,
          mapboxgl: mapboxgl
        })
    );

    this.map.addControl(new mapboxgl.NavigationControl());
    //////////////////////////////////////////////////



    this.map.on('load', () => {

      //******************************************
      // Add terrain
      this.map.addSource('mapbox-rui-terrain', {
        'type': 'raster-dem',
        'url': 'mapbox://mapbox.mapbox-terrain-dem-v1',
        'tileSize': 512,
        'maxzoom': 14
      });
      // add the DEM source as a terrain layer with exaggerated height
      this.map.setTerrain({ 'source': 'mapbox-rui-terrain', 'exaggeration': 1 });

      // add a sky layer that will show when the map is highly pitched
      this.map.addLayer({
        'id': 'sky',
        'type': 'sky',
        'paint': {
          'sky-type': 'atmosphere',
          'sky-atmosphere-sun': [0.0, 0.0],
          'sky-atmosphere-sun-intensity': 15
        }
      });

      
      //******************************************
      // Add building resources
      this.map.addSource('data_from_rui', {
        // GeoJSON Data source used in vector tiles, documented at
        // https://gist.github.com/ryanbaumann/a7d970386ce59d11c16278b90dde094d
        'type': 'geojson',
        'data':
        "https://raw.githubusercontent.com/ruirzma/Portland_dataset/main/Portland.geojson"
      });

      this.map.addLayer({
        'id': 'data_from_rui-extrusion',
        'type': 'fill-extrusion',
        'source': 'data_from_rui',

        'paint': {
          'fill-extrusion-color':'#ff4136',
          'fill-extrusion-height': ['get', 'AVG_HEIGHT'],
          'fill-extrusion-base': ['get', 'MIN_HEIGHT'],
          'fill-extrusion-opacity': 0.9
        }
      });

      // Get the map style and set it in the state tree
      // .getStyle mapbox api
      const style = this.map.getStyle();

      console.log("#####################In the ReactMap.js style:####################")
      console.log(style)
      console.log("#####################In the ReactMap.js style:#####################")

      this.props.setStyle(style);

      this.map.on('click', e => {
        const features = this.map.queryRenderedFeatures(e.point);

        console.log("#####################In the ReactMap.js e:####################")
        console.log(e)
        console.log("#####################In the ReactMap.js e:#####################")

        console.log("#####################In the ReactMap.js features:#####################");
        console.log(features);
        console.log( this.props.userInterface.get('activeLayer'))
        console.log("#####################In the ReactMap.js features:#####################");

        // Send a specific feature to the action/reducer:
        const currentLayer = this.props.userInterface.get('activeLayer');
        const selectedFeature = features.filter(f => f.layer.id === currentLayer);

        // console.log(currentLayer) --> buildings
        console.log("#####################In the ReactMap.js selectedFeature:#####################");
        console.log(selectedFeature);
        console.log(selectedFeature[0]);
        console.log("#####################In the ReactMap.js selectedFeature:#####################");

        this.props.clickMap(selectedFeature[0]);

        // Make a popup from stateful markup:
        // mapboxgl.Popup() --> mapbox API
        if(this.props.showPopUp && this.props.userInterface.get('popup') != null) {
          new mapboxgl.Popup()
            .setLngLat(e.lngLat)
            .setHTML(this.props.userInterface.get('popup'))
            .addTo(this.map);
        }
      });
    });
  }


  // Utilizes diffStyles to update the DOM map from a new Immutable stylesheet
  componentWillReceiveProps(nextProps) {
    if(this.props.mapStyle === null) return;

    const before = this.props.mapStyle;
    const after = nextProps.mapStyle;
    const map = this.map;

    if(!Immutable.is(before, after)) {
      const changes = diffStyles(before.toJS(), after.toJS());
      changes.forEach(change => {
        if(change.command == 'updateSource'){
          // This is a workaround patch for updateSource not being
          // low level enough for a generic apply command - dff.js has also
          // been patched.
          this.map.getSource(change.args[0]).setData(change.args[1].data);
        } else {
          map[change.command].apply(map, change.args);
        }
      });
    }
  }

  render(){
    return (
      <div id='map'></div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    clickMap: clickMap,
    setStyle: setStyle
  }, dispatch);
}
function mapStateToProps(state) {
  return {
    mapStyle: state.mapStyle,
    userInterface: state.userInterface
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ReactMap);
